import React, { forwardRef, useState } from 'react'
import { WidgetInputTextProps } from '../../widget-inputs'
import { SearchIcon } from '../../../../atoms/widget-icon/icons/search-icon'
import styles from '../../widget-inputs.module.scss'
import { WidgetInputWrapper } from '../widget-input-wrapper/widget-input-wrapper'
import { WidgetIcon } from '@/atoms/widget-icon'

export const WidgetInputSearch = forwardRef<
  HTMLInputElement,
  WidgetInputTextProps
>((props, ref) => {
  const {
    type,
    label,
    value,
    name,
    placeholder,
    error,
    disabled,
    required,
    autoComplete = 'off',
    onChange,
    inputStyles,
    labelStyles,
  } = props

  const errorClass = error
    ? styles['form__field__error']
    : styles['form__field']

  const requireClass = required
    ? `${styles['form__label']} ${styles['form__label--required']}`
    : styles['form__label']

  return (
    <WidgetInputWrapper>
      <div className={styles['search__icon']} data-testid="input-search">
        <WidgetIcon name={'search'} />
      </div>

      <input
        type={type}
        id={name}
        defaultValue={value}
        className={errorClass}
        placeholder={placeholder}
        onChange={onChange}
        disabled={disabled}
        autoComplete={autoComplete}
        ref={ref}
        style={inputStyles}
      />
      <label htmlFor={name} className={requireClass} style={labelStyles}>
        {placeholder}
      </label>
    </WidgetInputWrapper>
  )
})

WidgetInputSearch.displayName = 'WidgetInputSearch'
